module.exports = __webpack_public_path__ + "static/img/TB1EBxZrwoQMeJjy0FoXXcShVXa-1127-508.5e688ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TB1EBxZrwoQMeJjy0FoXXcShVXa-1127-508.png
// module id = WPZY
// module chunks = 1